import {adaptador_pedido_pago} from "../Adaptadores/adaptador_pedido_pago";
import axios from "axios";

export const envioDatosMercadoPago = (entidad) => {

    let pago = adaptador_pedido_pago(entidad)

    let data = JSON.stringify(pago);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
      //  url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/2cbe468e-eb76-477e-bd8c-7485f1437023', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/2cbe468e-eb76-477e-bd8c-7485f1437023',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios.request(config)
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            return error.message;
        });


}